import React from "react";
import {PlayerItem, FriendState} from "../PlayerItem";
import {User} from "../../../models/User";
import {useTranslation} from "react-i18next";

type FriendRequestsType = {
    usersWithPendingRequest: User[];
    acceptRequest: (user: User) => void;
    declineRequest: (user: User) => void;
}

export const FriendRequests: React.FC<FriendRequestsType> = (props) => {
    const {t} = useTranslation();

    return (
        <>
            {props.usersWithPendingRequest.length === 0 ?
                <div className="flex flex-col justify-center items-center h-1/2">
                    <p className="text-2xl">{t("global.its-empty")}</p>
                </div>
                :
                <div className="flex flex-col gap-3">
                    {props.usersWithPendingRequest.map(user => (
                        <PlayerItem
                            user={user}
                            friendState={FriendState.sentYouRequest}
                            acceptRequest={props.acceptRequest}
                            declineRequest={props.declineRequest}
                        />
                    ))}
                </div>
            }
        </>
    )
}
